import { createBarGraph } from './createBarGraph';

export default createBarGraph(['Savings Withdrawals', 'Guaranteed Income', 'Social Security'], 5000);
